export default __webpack_public_path__ + "9f4e050427096e46780bb035ef5949ce.png";